import script from "./ConfirmationHover.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmationHover.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmationHover.vue?vue&type=style&index=0&id=61c7c298&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\digi_aj\\source\\repos\\1ANAB_Vue_Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61c7c298"]])

export default __exports__